module.exports = __webpack_public_path__ + "static/key-barotrauma-0106a6c56e4325dbde2ecc9b2e9fcdd6.webp";